import { render } from "./outSelect.vue?vue&type=template&id=963972e2&scoped=true"
import script from "./outSelect.vue?vue&type=script&lang=js"
export * from "./outSelect.vue?vue&type=script&lang=js"

import "./outSelect.vue?vue&type=style&index=0&id=963972e2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-963972e2"]])

export default __exports__